<template>
    <!--
        tbId : 어느 테이블의 캡션 속성 필드를 받아올지 명시 인자값 (ex lead(리드) , sale(영업기회) , company(회사), 등등)
        cap_seq : 저장된 테이블 seq번호 (어디 데이터와 매칭시킬지 정하는 seq > 조회 및 등록때 필요)
    -->



    <div class="col-md-3" v-for="(item,index) in state.captionList" :key="index">
        <!-- case 1 : input-->
        <div class="mb-3" v-if="item.cd_id == 'CAP01'">
            <ElLabel :name="item.caption_nm" :required="item.cp_required == 'Y'" >
                <template v-slot:end="{id}">
                    <ElInput :id="id" v-model="state.captionData[`${item.col_id}`]"  :maxlength='item.cp_lengt' :readonly="props.readonly"/>
                </template>
            </ElLabel>
        </div>

        <!-- case 2 : date-->
        <div class="mb-3" v-else-if="item.cd_id == 'CAP02'">
            <ElLabel :name="item.caption_nm" :required="item.cp_required == 'Y'" >
                <template v-slot:end="{id}">
                    <DatePicker
                    :id="id"
                    :selectDate="state.captionData[`${item.col_id}`]"
                    @return="r=>state.captionData[`${item.col_id}`] = r"
                    :disabled="props.readonly"
                    />
                </template>
            </ElLabel>

        </div>


        <!-- case 3 : select-->
        <div class="mb-3" v-else-if="item.cd_id == 'CAP03'">
            <ElLabel :name="item.caption_nm" :required="item.cp_required == 'Y'" >
                <template v-slot:end="{id}">
                    <SelectCode
                        :id="id"
                        :cd_gr="item.cp_cd"
                        :matchCd="state.captionData[`${item.col_id}`]"
                        @return="r=>state.captionData[`${item.col_id}`] = r.cd_id"
                        :isShow="!props.readonly"
                    />
                </template>
            </ElLabel>
        </div>

        <!-- case 3 : radio-->
        <!-- <div class="mb-3" v-else-if="item.cp_format == 'radio'">
            <label for="" class="form-label">{{ item.caption_nm }}</label>
            <div class="form-check form-switch">
            </div>
        </div> -->
        
    </div>

</template>


<script setup>
import {onBeforeMount,reactive,watch} from 'vue'
import SelectCode from './SelectCode.vue';
import DatePicker from './DatePicker.vue';
import { useUserStore } from '@/store/user'
const userStore = useUserStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { cpList, cpCtntSelect, cpCtntEdit } from '@/api/capr';
const props = defineProps({
    tbId : {
        type : String,
        default : ''
    },
    cap_seq : {
        type : String,
        default : null
    },
    readonly : {
        type : Boolean,
        default : false
    },
})
const state = reactive({
    captionList : [],
    captionData :{
        ss_user_id : userStore.user.employeeId,
        tb_id : props.tbId,
        seq : null,
        cap_seq : null
    },
})


onBeforeMount(async()=>{
    try {
        setIsLoading(true)
        await getCpList()
        if(props.cap_seq){
            await getCpCtntSelect()
        }
    } catch (err) {
        console.error(err)
    } finally {
        setIsLoading(false)
    }
})

watch(
  () => props.cap_seq,
  (newVal,oldVal) => {
    getCpCtntSelect()
  }
)

//caption 속성 조회
const getCpList = async()=>{
    let params = {
        tb_id : props.tbId,
        enable_yn: 'Y'
    }
    try {
        const res = await cpList(params)
        state.captionList = res.rtn.map((item,index)=>{
            if(item.cd_id == 'CAP01'){
                state.captionData[`${item.col_id}`] = ''
            }else if(item.cd_id == 'CAP02'){
                state.captionData[`${item.col_id}`] = ''
            }else if(item.cd_id == 'CAP03'){
                state.captionData[`${item.col_id}`] = ''
            }
            return item
        })
    } catch (err) {
        throw new Error(err)
    }
}
//필수값 체크
const checkValidation = async()=>{
    //필수값 col id 추출
    let requiredData = state.captionList.filter((item)=>{if(item.cp_required === 'Y') return item})
    let flag = true
    requiredData.some((item)=>{
        if(!state.captionData[item.col_id]){
            alert(`${item.caption_nm}은 필수값입니다.`)
            flag = false
            return true
        }
    })

    return new Promise((resolve, reject) => {
        resolve(flag)
	})
}


//caption 내용 조회
const getCpCtntSelect = async(tb_id,cap_seq) =>{
    let params = {
        tb_id: tb_id || props.tbId,
        cap_seq: cap_seq ||props.cap_seq
    }
    try {
        const res = await cpCtntSelect(params)
        state.captionData.seq = res.rtn ? res.rtn.seq : ''
        for(let key in state.captionData){
            for(let resKey in res.rtn){
                if(key === resKey){
                    state.captionData[key] = res.rtn[key]
                }
            }
        }
    } catch (err) {
        throw new Error(err)
    }
}


//caption 내용 저장
const saveCapCtnt = async(cap_seq,tbId,seq)=>{
    //서버단에서 seq 변수명으로 체크를 통해 insert/update
    state.captionData.cap_seq = cap_seq
    state.captionData.tb_id = tbId || props.tbId
    if(seq){
        state.captionData.seq = seq
    }
    return await cpCtntEdit(state.captionData)
}

//임시저장
const saveTempCapCtnt = async(cap_seq,tbId)=>{
    //서버단에서 seq 변수명으로 체크를 통해 insert
    state.captionData.cap_seq = cap_seq
    state.captionData.seq = null
    state.captionData.tb_id = tbId || props.tbId
    return await cpCtntEdit(state.captionData)
}

function setSeq(val){
    state.captionData.seq = val
}
defineExpose({
    saveCapCtnt,
    checkValidation,
    saveTempCapCtnt,
    setSeq,
    state
})
</script>
